export function isLoaded(globalState) {
  return globalState.notes && globalState.notes.loaded;
}

export const VIEW_START = "app/notes/VIEW_START";
export function viewStart(note) {
  return { type: VIEW_START, note };
}

export const VIEW_STOP = "app/notes/VIEW_STOP";
export function viewStop() {
  return { type: VIEW_STOP };
}

export const ADD_START = "app/notes/ADD_START";
export function addStart() {
  return { type: ADD_START };
}

export const EDIT_START = "app/notes/EDIT_START";
export function editStart(id) {
  return { type: EDIT_START, id };
}

export const FORM_CHANGE = "app/notes/FORM_CHANGE";
export function formChange(formData) {
  return { type: FORM_CHANGE, formData };
}

export const FORM_STOP = "app/notes/FORM_STOP";
export function formStop(id) {
  return { type: FORM_STOP, id };
}

import { usePost, useGet, usePut } from "./useRequest";

export const loadNotes = (note, noteTypeId = null) => {
  const path = "/notes/" + note.entityId + "/" + note.entityType + (noteTypeId ? "?noteTypeId=" + noteTypeId : "");
  const response = useGet(path);

  return response;
};

export const addNote = (note) => {
  const path = "/notes/" + note.entityId + "/" + note.entityType;
  const response = usePost(path, note);
  return response;
};

export const editNote = (note) => {
  const path = "/notes/" + note.entityId + "/" + note.entityType;
  const response = usePut(path, note);
  return response;
};

export const loadNoteTypes = () => {
  const path = "/notetypes";
  const response = useGet(path);
  return response;
};

export function loadEmailByNote(id) {
  const path = "/notes/" + id + "/email";
  const response = useGet(path);
  return response;
}

export function loadViewMoreNote(id) {
  const path = "/candidatescoredetails/" + id;
  const response = useGet(path);
  return response;
}

export const loadSearchEmailNotes = (profileId) => {
  const path = "/emails/searchandmatchprofile/" + profileId;
  const response = useGet(path);
  return response;
};

export const loadTalentPoolEmailNotes = (candidateId) => {
  const path = "/emails/talentpoolcandidate/" + candidateId;
  const response = useGet(path);
  return response;
};
